import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../config/core.httpclient-utils';

@Injectable()
export class AdminService {

    constructor(private http: HttpClient) {
        this.http = http;
    }

    users(params: any = {}) {
        return doGetPromise(this.http, `/api/user/`, params);
    }

    getUser(unixName: string, rel: string = 'projects,activitylog,groups,lock') {
        return doGetPromise(this.http, `/api/user/${unixName}/details`, { rel });
    }

    postPassword(unixName: string, data: any = {}) {
        return this.http.post(`/api/user/${unixName}/password`, data)
        .toPromise();
    }

    // Used to update user details: UserRest.update()
    newUser(data: any = {}) {
        return this.http.post(`/api/user/0/details`, data)
        .toPromise();
    }

    troveCategories() {
        return doGetPromise(this.http, `/api/trove`);
    }

    troveProjects(projectId: any = 0) {
        return doGetPromise(this.http, `/api/trove/${projectId}/projects`);
    }

   postTrove(id: any = 0, data: any = {}) {
        return this.http.post(`/api/trove/${id}`, data)
        .toPromise();
    }

    postAuthSettings(data: any = {}) {
        return this.http.post(`/api/admin/0/authsettings`, data)
            .toPromise();
    }

    postConfig(data: any = {}) {
        return this.http.post(`/api/setting/${data.section}/${data.refId}/${data.settingName}`, data)
        .toPromise();
    }

    deleteConfig(section: string = '', refId: number = 0, settingName: string = '') {
        return this.http.delete(`/api/setting/${section}/${refId}/${settingName}`)
        .toPromise(); 
    }

    getConfig(section: string = '', refId: number = 0, settingName: string = '', defaultValue: any = '') {
        return doGetPromise(this.http, `/api/setting/${section}/${refId}/${settingName}`)
            .then((res) => {
                return res;
            }, () => {
                return {
                    section: section,
                    refId: refId,
                    settingName: settingName,
                    settingValue: defaultValue
                };
            });
    }

    getCronjobs(params: any = {}) {
        return doGetPromise(this.http, `/api/admin/0/cronjobs`, params);
    }

    putCronjobs(params: any = {}) {
        return this.http.put(`/api/admin/0/cronjobs`, params).toPromise();
    }

    getExtraAuthSettings(params: any = {}) {
        return doGetPromise(this.http, `/api/admin/0/authsettings`, params);
    }

    getAuthMethods(params: any = {}) {
        return doGetPromise(this.http, `/site/authmethods`, params);
    }

    deleteTrove(id: number = 0) {
        return this.http.delete(`/api/trove/${id}`)
        .toPromise(); 
    }

    projects(params: any = {}) {
        return doGetPromise(this.http, `/api/project`, params);
    }

    groupUsers(unixName: string = '') {
        return doGetPromise(this.http, `api/user/${unixName}/groupUsers`);
    }

    updateGroup(userId: number = 0, data: any = {}) {
        return this.http.put(`api/user/${userId}/group`, data)
        .toPromise(); 
    }

    createGroup(userId: number = 0, data: any = {}) {
        return this.http.post(`api/user/${userId}/group`, data)
        .toPromise(); 
    }

    deleteGroup(userId: number = 0) {
        return this.http.delete(`api/user/${userId}/group`)
        .toPromise(); 
    }

    report(params: any = {}) {
        return doGetPromise(this.http, `/api/report/0/site`, { ...params, report: true });
    }

    postNotification(data: any = {}) {
        return this.http.post(`/api/sitenotification`, data)
        .toPromise(); 
    }
}
